import { render, staticRenderFns } from "./AssistanceShare.vue?vue&type=template&id=b39ab384&scoped=true&lang=html&"
import script from "./AssistanceShare.vue?vue&type=script&lang=js&"
export * from "./AssistanceShare.vue?vue&type=script&lang=js&"
import style0 from "./AssistanceShare.vue?vue&type=style&index=0&id=b39ab384&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39ab384",
  null
  
)

export default component.exports